import { BffApiClient } from '@/common/services/api/bffClient';
import { wardMenuLinksEndpoints } from '../endpoints/menuLinksEndpoints';
import { MenuLinkModel, MenuLinkPayloadModel } from '../types/menuTypes';

export class MenuLinkService {
  private static api = BffApiClient.getInstance();

  static async getLinks(): Promise<MenuLinkModel[]> {
    const response = await this.api.get(`${wardMenuLinksEndpoints.getLinks}`);
    return response.data as MenuLinkModel[];
  }

  static async getLinksIds(ids: number[]): Promise<MenuLinkModel[]> {
    const response = await this.api.get(`${wardMenuLinksEndpoints.getLinksIds(ids)}`);
    return response.data as MenuLinkModel[];
  }

  static async getLinkById(id: number): Promise<MenuLinkModel> {
    const response = await this.api.get(`${wardMenuLinksEndpoints.getLinkById(id)}`);
    return response.data as MenuLinkModel;
  }

  static async createLink(linkData: MenuLinkPayloadModel): Promise<MenuLinkModel> {
    const response = await this.api.post(`${wardMenuLinksEndpoints.createLink}`, linkData);
    return response.data as MenuLinkModel;
  }

  static async updateLink(id: number, linkData: MenuLinkModel): Promise<MenuLinkModel> {
    const response = await this.api.put(`${wardMenuLinksEndpoints.updateLink(id)}`, linkData);
    return response.data as MenuLinkModel;
  }

  static async deleteLink(id: number): Promise<void> {
    await this.api.delete(`${wardMenuLinksEndpoints.deleteLink(id)}`);
  }
}
